import { Container, Row, Col, Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Password.css';

import tutorImg from '../shared/image/Dial_Tutor.png';

export default function StudentPassword() {
  return (
    <Container fluid className="mainss-containerss">
      <Row className="loginss-cardss">
        <Col md={6} className="image-section">
          <img src={tutorImg} alt="Dialtutor" />
        </Col>
        <Col md={6} className="formss-sectionss">
          <h4 className="mb-4">Forgot Password</h4>
          <Alert variant="info" className="py-2 mb-3">
            <p className="mb-2">To reset your password, contact our team and we'll set a new one for you within a few hours:</p>
            <div className="mb-1">📞 <a href="tel:7448337000" className="alert-link">7448337000</a></div>
            <div>📧 <a href="mailto:support@dialtutors.in" className="alert-link">support@dialtutors.in</a></div>
            <p className="small mb-0 mt-2 text-muted">Have your registered email ready when you call.</p>
          </Alert>
          <Button as={Link} to="/student/login" className="subtss">
            Back to Login
          </Button>
        </Col>
      </Row>
    </Container>
  );
}
